import { useState, useEffect, useRef, useCallback } from "react"
import * as XLSX from 'xlsx';
 
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import { Alert } from "@material-ui/lab";
import { Divider } from "@material-ui/core";

import IconButton from '@material-ui/core/IconButton'
import DoneAllOutlinedIcon from '@material-ui/icons/DoneAllOutlined';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import { green, red } from "@material-ui/core/colors";

import Dialog from "@base/Dialog";
import { ButtonSave } from "@base/Button/ButtonForm"
import Toast from '@base/Toast'
import SelectOption from '@base/Inputs/Select'

import AtividadeService from '@services/AtividadeService'
import ProcessoService from '@services/ProcessoService'
import ColaboradorService from '@services/ColaboradorService'

import useEmpresas from '@hooks/enums/useEmpresas';

import { sizeFiles } from '@helpers/FileHelper'
import { removerEspacos } from '@helpers/ValidationHelper'

export const ColaboradorLoteDialog = ({ aberto, aoFechar }) => {
	const [loading, setLoading] = useState(false);

	const [processo, setProcesso] = useState("");
	const [atividade, setAtividade] = useState("");
	const [empresa, setEmpresa] = useState("");
	const [file, setFile] = useState(null);

	const [listagemAtividade, setListagemAtividade] = useState([]);
	const [listagemColaborador, setListagemColaborador] = useState([]);
	const listagemEmpresa = useEmpresas();

	const toastRef = useRef(null);

	const handleUploadPlanilha = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();
		
		reader.onload = (event) => {
			const workbook = XLSX.read(event.target.result, { type: 'binary' });
			const worksheet = workbook.Sheets[workbook.SheetNames[0]];
			const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
			
			setListagemColaborador([...jsonData.map(json => { return { nome: json[0], sobrenome: json[1], email: removerEspacos(json[2]), processo: processo, status: null }; }) ]);
		};
		
		reader.readAsBinaryString(file);
		setFile(file);
	};

	const handleSubmit = async () => {
		setLoading(true);

		if (!atividade) {
			toastRef.current.show("error", `o Campo 'Atividade' deve estar Preenchido.`);
			setLoading(false);
			return 
		}

		Promise.all(
			listagemColaborador.map(async c => {
				let obj = {
					nome : c.nome,
					sobrenome : c.sobrenome,
					email : c.email.trim(),
					atividade: atividade,
					empresa: empresa,
					processo: processo,
				};

				if(c.email === "") {
					toastRef.current.show("error", `O Email é obrigatório para o Colaborador ${c.nome} ${c.sobrenome}.`);
					c.status = false;
				} else {
					await ColaboradorService.adicionar(obj).then(res => c.status = true).catch(error => 
						{
						c.status = false
						c.erro = error.response.data.mensagens.map(mensagem => mensagem).join(" ,");
						console.log(error);

					})
				}
				
				return c;
			})
		).then((res) => {
			setListagemColaborador([...res])
			console.log(res);
			return res;

		}).then((res) => {
			console.log(res);
			setLoading(false);

			if (res.every(c => c.status)) {
				toastRef.current.show("success", `Os Colaboradores foram Inseridos com Sucesso!`);
				setTimeout(() => fecharDialog(), 3000);
			} else if (res.every(c => !c.status)) {
				toastRef.current.show("error", `Ocorreu um Problema ao Cadastrar os Colaboradores.`);
			} else if (res.some(c => !c.status) && listagemColaborador.some(c => c.status)) {
				toastRef.current.show("warning", `Os Colaboradores foram Parcialmente Cadastrados! Verifique os Alertas.`);
			}			
		})
	}
	
	const fecharDialog = () => {
		setAtividade("");
		setEmpresa("");
		setListagemColaborador([]);
		aoFechar();
	}

	const carregarDados = useCallback(() => {
		if (aberto) {
			ProcessoService.buscarProcessoEmAndamento().then(resultado => {
				setProcesso(resultado.data.id);
			});

			AtividadeService.listar().then(resposta => {
				setListagemAtividade(resposta.data.content.map(atividade => {
					return {
						label : atividade.descricao,
						value : atividade.id
					};
				}));	
			});
		}
	}, [ aberto ]);

	useEffect(() => carregarDados(), [carregarDados]);

	return (
		<>
			<Toast ref={toastRef} />
			<Dialog
				maxWidth={"lg"}
				fullWidth={true}
				closeDialog={fecharDialog}
				openDialog={aberto}
				title={"Importar Colaboradores em Lote"}
				actions={<ButtonSave onClick={handleSubmit} loading={loading} />}>

				<Grid container spacing={12}>
					<Grid item sm={12}>
						<Alert severity="info" style={{ display: 'flex', alignItems: 'center' }}>
							<ul>
								<li>O formato utilizado para importação deverá ser o <b>.xlsx</b>;</li>
								<li>A planilha deverá ter 3 colunas obrigatóriamente na ordem de <b>NOME</b>, <b>SOBRENOME</b> e <b>EMAIL</b>;</li>
								<li>A planilha <b>NÃO</b> deverá conter cabeçalho;</li>
								<li>Ao submeter a planilha deverá ser mostrada uma prévia dos dados contidos, mas a importação só será realizada ao clicar no botão de <b>SALVAR</b> no fim da listagem;</li>
								<li>A importação é feita de uma a uma, onde o status de cada importação será mostrado na coluna <b>Status de Cadastro</b>, onde em caso de erro o colaborador deverá ser reimportado;</li>
								<li>Colaboradores com email já existentes <b>NÃO</b> serão importados novamente.</li>
							</ul>
						</Alert>
					</Grid>
				</Grid>
				<br />

				<Grid container spacing={12}>
					<Grid item sm={12}>
						<Button
							variant="contained"
							component="label"
							color="primary"
							style={{ margin: 4 }}
						>
							Selecionar Arquivo <sup style={{ marginLeft: 8 }}>*</sup>
							<input
								required
								type="file"
								name="file"
								accept=".xlsx"
								style={{ display: "none" }}
								onChange={(e) => handleUploadPlanilha(e)}
							/>
						</Button>

						{ file &&
							<Typography variant="overline" display="inline" style={{ margin: 16 }} gutterBottom >{file.name} - {sizeFiles(file.size)}</Typography>						
						}
					</Grid>
				</Grid>

				{ listagemColaborador.length > 0 &&
					<>	
						<Divider />

						<Grid container spacing={3}>
							<Grid item sm={12} lg={6}>
								<SelectOption
									label='Selecione a Atividade dos Colaboradores'
									value={atividade}
									name='atividade'
									onChange={(e) => setAtividade(e.target.value)}
									options={listagemAtividade} 
								/>
							</Grid>
							<Grid item sm={12} lg={6}>
								<SelectOption
									label='Selecione a Empresa dos Colaboradores'
									value={empresa}
									name='empresa'
									onChange={(e) => setEmpresa(e.target.value)}
									options={listagemEmpresa.data} 
								/>
							</Grid>
						</Grid>

						<Grid container spacing={3}>
							<Grid item sm={12} lg={12}>
								<Table size="small">
									<TableHead>
										<TableRow>
											<TableCell><b>#</b></TableCell>
											<TableCell><b>Nome</b></TableCell>
											<TableCell><b>Sobrenome</b></TableCell>
											<TableCell><b>Email</b></TableCell>
											<TableCell align="center"><b>Status de Cadastro</b></TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{listagemColaborador.map((c, key) => (
											<TableRow key={key} hover>
												<TableCell>{key + 1}</TableCell>
												<TableCell>{c.nome}</TableCell>
												<TableCell>{c.sobrenome}</TableCell>
												<TableCell>{c.email}</TableCell>
												<TableCell align="center">
													{c.status != null ? 
														c.status ? 
															<Tooltip title="Cadastrado com Sucesso" TransitionComponent={Zoom}>
																<IconButton size="small" component="div" style={{ color: green[600]}}><DoneAllOutlinedIcon /></IconButton>
															</Tooltip>
														: 
															<Tooltip title={c.erro} TransitionComponent={Zoom}>
																<IconButton size="small" component="div" style={{ color: red[800]}}><ClearOutlinedIcon /></IconButton>
															</Tooltip>
													: 
														<Tooltip title="Aguardando Cadastro" TransitionComponent={Zoom}>
															<IconButton size="small" component="div" ><CheckOutlinedIcon /></IconButton>
														</Tooltip>
													}
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</Grid>
						</Grid>
					</>
				}				
			</Dialog>
		</>
	);
}

export default ColaboradorLoteDialog;
